import React, { useState } from "react";
import { motion } from "framer-motion";

const FOUNDER_1 =
  "https://static.prod-images.emergentagent.com/jobs/1244c932-ba4e-452c-af76-86755415d04f/images/efcec4a99b635581c66fa401dcdf450348c440a6a7ee5a4c77b9be93252defbf.png";
const FOUNDER_2 =
  "https://static.prod-images.emergentagent.com/jobs/1244c932-ba4e-452c-af76-86755415d04f/images/208209f7d1e5fc11aca54f21599ffe2c1edcaead7f9adbbf028afd6641758a35.png";

const FOUNDERS = [
  { image: FOUNDER_1, role: "CEO & CO-FOUNDER", initials: "F.01" },
  { image: FOUNDER_2, role: "CTO & CO-FOUNDER", initials: "F.02" },
];

const FounderCard = ({ founder, index }) => {
  const [hovered, setHovered] = useState(false);

  return (
    <motion.div
      data-testid={`team-card-${index}`}
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.15, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      viewport={{ once: true }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Image container */}
      <div
        style={{
          overflow: "hidden",
          marginBottom: "18px",
          aspectRatio: "3/4",
          border: `1px solid ${hovered ? "#FF3B00" : "#1A1A1A"}`,
          transition: "border-color 0.4s ease",
        }}
      >
        <img
          src={founder.image}
          alt={`Anantora ${founder.role}`}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center top",
            filter: hovered
              ? "grayscale(40%) brightness(0.8)"
              : "grayscale(100%) brightness(0.65)",
            transform: hovered ? "scale(1.05)" : "scale(1)",
            transition: "filter 0.6s ease, transform 0.6s ease",
            display: "block",
          }}
        />
      </div>

      {/* Card footer */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <span
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: "9px",
              color: "#FF3B00",
              letterSpacing: "0.2em",
              display: "block",
              marginBottom: "4px",
            }}
          >
            {founder.role}
          </span>
          <span
            style={{
              fontFamily: "'Cabinet Grotesk', sans-serif",
              fontWeight: 700,
              fontSize: "18px",
              color: "#F4F4F0",
              letterSpacing: "-0.01em",
            }}
          >
            Anantora
          </span>
        </div>
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "9px",
            color: "#2A2A2A",
            letterSpacing: "0.1em",
          }}
        >
          {founder.initials}
        </span>
      </div>
    </motion.div>
  );
};

const Team = () => (
  <section
    data-testid="team-section"
    id="team"
    style={{
      padding: "clamp(80px, 12vw, 160px) clamp(24px, 6vw, 96px)",
      borderTop: "1px solid #1A1A1A",
    }}
  >
    {/* Header */}
    <div
      style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginBottom: "clamp(48px, 6vw, 80px)" }}
      className="flex-col md:flex-row gap-6 md:gap-0"
    >
      <div>
        <span
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "11px",
            color: "#FF3B00",
            letterSpacing: "0.22em",
            display: "block",
            marginBottom: "14px",
          }}
        >
          [03]
        </span>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          viewport={{ once: true }}
          style={{
            fontFamily: "'Cabinet Grotesk', sans-serif",
            fontWeight: 800,
            fontSize: "clamp(2.8rem, 5vw, 5rem)",
            lineHeight: 0.95,
            letterSpacing: "-0.03em",
            color: "#F4F4F0",
            textTransform: "uppercase",
            margin: 0,
          }}
        >
          Who<br />We Are
        </motion.h2>
      </div>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.8 }}
        viewport={{ once: true }}
        style={{
          fontFamily: "'Inter', sans-serif",
          fontSize: "15px",
          color: "#666666",
          lineHeight: 1.7,
          margin: 0,
          maxWidth: "360px",
        }}
      >
        A small, focused team with deep conviction in what software can be.
      </motion.p>
    </div>

    {/* Founders grid */}
    <div
      style={{ display: "grid", gap: "clamp(16px, 3vw, 32px)", maxWidth: "760px" }}
      className="grid-cols-2"
    >
      {FOUNDERS.map((founder, i) => (
        <FounderCard key={i} founder={founder} index={i} />
      ))}
    </div>
  </section>
);

export default Team;
